require('./_shared');

(function () {

	$(document).ready(function () {

        $('.carousel').each(function () {

            var theCarousel = this;

            $(this).find('.carousel-indicators li').on('click', function (e){
                e.stopPropagation();
                $(theCarousel).carousel($(this).index());
            });

        });

    });

	$(document).on('click', 'a[href^="#"]:not([data-toggle])', function (e) {
	    e.preventDefault();
	    var targetId = this.getAttribute('href');
	    if ( targetId !== '#' ) {
	    	var top = $(targetId).offset().top;
	    	$('html, body').stop().animate({scrollTop: top }, 1000);
		}
	});

}())


//////////////////
// WEBPACK FOOTER
// ./assets/entrypoints/professional/_skeleton.js
// module id = 0
// module chunks = 15